import React from 'react'
import { graphql } from 'gatsby'
import ReactMarkdown from 'react-markdown'
import Layout from '../components/layout'
import InsideHeader from '../components/insideheader'
import Project from '../components/project'

export default ({ data }) => {
  const page = data.dataJson
  return (
    <Layout>
      <InsideHeader
        pageTitle={page.title}
        pageSubTitle={page.subTitle}
        pageSlug={page.slug} 
        headerImage={page.titleBackground}
      />
      <main className="main-content">
        <section className="section">
          <div className="row">
            <div className="col-md-12 mx-2 mx-md-auto">
              {page.contents.map(item => (
                <div className="row mx-auto gap-y gap-2 justify-content-center">
                  {item.heading && (
                    <div className="row col-12 justify-content-center">
                      <div className="col-md-9 text-center">
                        <ReactMarkdown source={item.heading} escapeHtml={false} />
                      </div>
                    </div>
                  )}
                  {item.content && (
                    <div className="row col-12 justify-content-center">
                      <div className='col-md-9 text-center'>
                        <ReactMarkdown source={item.content} escapeHtml={false} />
                      </div>
                    </div>
                  )}

                  {item.projects.map(project => (
                    <Project project={project} />
                  ))}
                  <div className="row col-12 justify-content-center">
                    <br />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!) {
    dataJson(fields: { slug: { eq: $slug } }) {
      title
      subTitle
      titleBackground
      contents {
        heading
        image
        content
        projects {
          name
          summary
          category
          image
          link
        }
      }
    }
  }
`
